/*
 * ByLamari: Kategorieseite, Teil 2 (routes/collection.tsx, Theme-Kopie B, 25.10.2026).
 *  - Leiste mit der Farbwahl klebt unter der Kopfzeile und folgt ihr (CSS data-klebt)
 *  - Filter-Fenster schickt bei jeder Wahl ab, Farbwahl und Wunsch bleiben in der Adresse
 *  - Hinweisleiste („3 für 2“ bzw. versandkostenfrei) folgt dem Warenkorb
 */
(function () {
  var wurzel = document.querySelector('[data-bl-koll]');
  if (!wurzel) return;

  /* Leiste klebt unter der Kopfzeile */
  var leiste = wurzel.querySelector('[data-bl-leiste]');
  var kopf = document.querySelector('.bl-header');
  if (leiste && kopf) {
    var oben = kopf.querySelector('.bl-header__oben'), hoeheKopf = kopf.offsetHeight;
    var messen = function () {
      hoeheKopf = kopf.offsetHeight;
      leiste.style.setProperty('--bl-kopfzeile', hoeheKopf + 'px');
      leiste.style.setProperty('--bl-kopfzeile-oben', (oben ? oben.offsetHeight : 0) + 'px');
    };
    if ('ResizeObserver' in window) new ResizeObserver(messen).observe(kopf); else messen();
    var wartet = false;
    var pruefe = function () {
      wartet = false;
      var klebt = leiste.getBoundingClientRect().top <= hoeheKopf + 1;
      if (klebt !== leiste.hasAttribute('data-klebt')) leiste.toggleAttribute('data-klebt', klebt);
    };
    pruefe();
    window.addEventListener('scroll', function () { if (!wartet) { wartet = true; requestAnimationFrame(pruefe); } }, { passive: true });
  }

  /* Filter-Fenster */
  function abschicken(form) {
    var p = new URLSearchParams(new FormData(form));
    Array.from(p.keys()).forEach(function (k) { if (p.get(k) === '') p.delete(k); });
    var jetzt = new URLSearchParams(location.search);
    ['farbe', 'wunsch'].forEach(function (k) { if (jetzt.get(k)) p.set(k, jetzt.get(k)); });
    location.href = form.getAttribute('action') + (p.toString() ? '?' + p.toString() : '');
  }
  document.addEventListener('change', function (e) {
    var form = e.target.closest && e.target.closest('[data-bl-filter-form]');
    if (!form) return;
    if (e.target.hasAttribute('data-bl-einzeln') && e.target.checked) {
      form.querySelectorAll('input[name="' + e.target.name + '"]').forEach(function (x) { if (x !== e.target) x.checked = false; });
    }
    if (e.target.hasAttribute('data-bl-preis-feld')) return;
    abschicken(form);
  });
  var preisTimer = 0;
  document.addEventListener('input', function (e) {
    if (!e.target.hasAttribute || !e.target.hasAttribute('data-bl-preis-feld')) return;
    clearTimeout(preisTimer);
    var form = e.target.form;
    preisTimer = setTimeout(function () { abschicken(form); }, 350);
  });

  /* Hinweisleiste folgt dem Warenkorb */
  function geld(c) { return (c / 100).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' }); }
  document.addEventListener('bl:warenkorb', function (ev) {
    var cart = ev.detail.cart, ringe = 0, gespart = 0;
    cart.items.forEach(function (i) {
      if (i.variant_id === 53831940145418 || i.product_type !== 'Ring') return;
      ringe += i.quantity;
      gespart += Math.max(0, i.original_line_price - i.final_line_price);
    });
    var rest = ringe % 3, schon = Math.floor(ringe / 3);
    var z = ringe === 0 ? 'start' : rest === 1 ? 'eins' : rest === 2 ? 'zwei' : 'aktiv';
    var voll = ringe === 0 ? 0 : rest === 0 ? 3 : rest;
    var text = z === 'start' ? '<span class="bl-hinweisleiste__titel">Leg 3 Ringe rein, einer ist gratis</span>'
      : z === 'eins' ? '<span class="bl-hinweisleiste__titel">' + (schon > 0 ? 'Noch 2 Ringe, dann ist noch einer gratis' : 'Noch 2 Ringe, dann ist einer gratis') + '</span>'
      : z === 'zwei' ? '<span class="bl-hinweisleiste__titel">Dein 3. Ring ist gratis</span> <span class="bl-hinweisleiste__unter">Such dir einen aus, er kostet 0 €.</span>'
      : '<span class="bl-hinweisleiste__titel"><span class="sr-only">3 für 2 </span>ist aktiv' + (gespart > 0 ? ', du sparst ' + geld(gespart) : '') + '</span>';
    var schluessel = z + '-' + schon + '-' + gespart;
    document.querySelectorAll('[data-bl-hinweis="ring"] .bl-hinweisleiste').forEach(function (l) {
      if (l._blZ === undefined) l._blZ = l.getAttribute('data-zustand');
      if (l._blZ === schluessel) return;
      l._blZ = schluessel;
      l.setAttribute('data-zustand', z);
      l.classList.remove('is-wechsel'); void l.offsetWidth; l.classList.add('is-wechsel');
      l.querySelector('.bl-hinweisleiste__text').innerHTML = text;
      l.querySelectorAll('.bl-hinweisleiste__platz').forEach(function (p, i) { p.classList.toggle('is-voll', i < voll); });
    });
    var summe = cart.items_subtotal_price, fehlt = Math.max(0, 3900 - summe), anteil = Math.min(1, summe / 3900);
    document.querySelectorAll('[data-bl-hinweis="versand"] .bl-hinweisleiste').forEach(function (l) {
      l.firstElementChild.textContent = fehlt > 0 ? 'Noch ' + geld(fehlt) + ' bis versandkostenfrei' : cart.item_count > 0 ? 'Dein Versand ist kostenlos' : 'Ab 39 € versandkostenfrei';
      l.querySelector('.bl-hinweisleiste__spur > span').style.transform = 'scaleX(' + anteil + ')';
    });
  });
})();